import { Checkbox, IconButton, Stack, Text, TooltipHost } from "@fluentui/react";
import { descriptionStyles, lgDescriptionStyles, lgTitleStyles, mdDescriptionStyles, mdTitleStyles, registerConfigurationAppTileContainerSelectedStyles, registerConfigurationAppTileContainerStyles, registerConfigurationAppTileInnerContainerSelectedStyles, registerConfigurationAppTileTextContainerStyles, smDescriptionStyles, smTitleStyles, titleStyles, xlDescriptionStyles, xlTitleStyles, xxlDescriptionStyles, xxlTitleStyles } from "../Styles/RegisterConfigurationStyles";
import { useBreakpoint } from "../../../../Container/ContainerStyles";
import { BreakpointType } from "../../../../Container/ContainerFluid";

export interface IRegisterConfigurationAppTileProps {
    title: string;
    priceString: string;
    selected: boolean;
    informationText: string;
    onChange: (isSelected: boolean) => void;
}

export const RegisterConfigurationAppTile: React.FC<IRegisterConfigurationAppTileProps> = (props) => {
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    return (
        <Stack
            grow
            className={props.selected ? registerConfigurationAppTileContainerSelectedStyles : registerConfigurationAppTileContainerStyles}
            onClick={() => props.onChange(!props.selected)}
        >
            <Stack
                grow
                horizontal
                horizontalAlign="space-between"
                verticalAlign="center"
                verticalFill
                className={props.selected ? registerConfigurationAppTileInnerContainerSelectedStyles : undefined}
            >
                <Stack
                    grow
                    horizontal
                    horizontalAlign="start"
                    verticalAlign="center"
                    verticalFill

                    className={registerConfigurationAppTileTextContainerStyles}
                >
                    <Checkbox
                        checked={props.selected}
                        onChange={() => props.onChange(!props.selected)}
                    />
                    <Stack
                        verticalFill
                        verticalAlign="center"
                    >
                        <Text
                            className={
                                isSM ? 
                                    smTitleStyles : 
                                isMD ? 
                                    mdTitleStyles : 
                                isLG ?
                                    lgTitleStyles :
                                isXL ?
                                    xlTitleStyles :
                                isXXL ?
                                    xxlTitleStyles
                                :
                                    titleStyles
                            }
                        >
                            {props.title}
                        </Text>
                        <Text
                            className={
                                isSM ? 
                                    smDescriptionStyles : 
                                isMD ? 
                                    mdDescriptionStyles :
                                isLG ?
                                    lgDescriptionStyles :
                                isXL ?
                                    xlDescriptionStyles :
                                isXXL ?
                                    xxlDescriptionStyles
                                :
                                    descriptionStyles
                            }
                        >
                            {props.priceString}
                        </Text>
                    </Stack>
                </Stack>
                <Stack>
                    <TooltipHost
                        content={props.informationText}
                        calloutProps={{ gapSpace: 0 }}
                        styles={{root:{display:'inline-block !important'}}}
                    >
                        <IconButton
                            iconProps={{ iconName: 'Info' }}
                        />
                    </TooltipHost>
                </Stack>
            </Stack>
        </Stack>
    );
}